import React, { useRef, useState } from "react";
import PackagesSection from "../utils/packageaccordion";
import { FaYoutube } from "react-icons/fa";
import { FaPlayCircle, FaVolumeMute } from "react-icons/fa";
import BookMeetingModal from "../utils/bookingmodal";
// images
import yourVideo from "../assest/video-10.mp4";
import heroImg from "../assest/description_top_banner.png";
import homeImg from "../assest/home.png";
import brickImg from "../assest/brick.png";
import shieldImg from "../assest/shield.png";

import designImg from "../assest/design.png";
import qualityImg from "../assest/qualityicon.png";
import priceImg from "../assest/price-icon.png";
import timeImg from "../assest/time-icon.png";

import houseLeft from "../assest/description_top_banner.png";
import houseCenter from "../assest/house-center.png";
import houseRight from "../assest/house-right.png";

import meetImg from "../assest/meet-experts.png";
import designHome from "../assest/design-home.png";
import trackImg from "../assest/track-construction.png";
import moveImg from "../assest/move-in.png";
import CityModal from "../utils/selectcitymodal";
import Footer from "./footer";

const projects = [
  {
    center: houseCenter,
    left: houseLeft,
    right: houseRight,
  },
  {
    center: houseLeft,
    left: houseRight,
    right: houseCenter,
  },
  {
    center: houseRight,
    left: houseCenter,
    right: houseLeft,
  },
];
const features = [
  {
    img: designImg,
    title: "Designs matching vision",
    desc: "Functional layouts that are unique to your lifestyle.",
  },
  {
    img: qualityImg,
    title: "High-quality materials",
    desc: "No compromises. Only certified-grade materials.",
  },
  {
    img: priceImg,
    title: "Price transparency",
    desc: "Clear pricing with no surprises, just peace of mind.",
  },
  {
    img: timeImg,
    title: "On-Time Delivery",
    desc: "From planning to handover, our turnkey model stays on schedule.",
  },
];
function Home() {
  const [index, setIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("Select City");
  const [openModal, setOpenModal] = useState(false);
  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === projects.length - 1 ? 0 : prev + 1));
  };
  const videoRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const handleTimeUpdate = () => {
    const video = videoRef.current;
    const percent = (video.currentTime / video.duration) * 100;
    setProgress(percent);
  };
  const handleSeek = (e) => {
    const video = videoRef.current;
    const width = e.target.clientWidth;
    const clickX = e.nativeEvent.offsetX;
    const duration = video.duration;

    video.currentTime = (clickX / width) * duration;
  };
  return (
    <div className="w-full overflow-x-hidden font-[Poppins]">
      {/* ================= HERO ================= */}
      {/* <section
        className="min-h-screen bg-cover bg-center flex flex-col justify-center relative pt-[80px] pb-[120px] px-6 md:px-[120px]"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="max-w-[600px]">
          <h1 className="text-[32px] md:text-[55px] lg:text-[70px] leading-[40px] md:leading-[65px] lg:leading-[80px] text-gray-500 font-bold font-serif">
            BUILD <br /> BEYOND <br /> EXPECTATION
          </h1>

          <p className="mt-4 text-[14px] md:text-[18px]">
            Build your dream home hassle-free with{" "}
            <span className="font-serif font-semibold">TORANA</span>.
          </p>

          <button className="mt-6 px-7 py-3 bg-[#d9b3ff] rounded-md hover:bg-[#c999ff]">
            Book a meeting
          </button>
        </div>

    
        <div
          className="absolute left-1/2 -translate-x-1/2 bottom-[-120px] md:bottom-[-40px]
          bg-white rounded-xl shadow-xl flex flex-col md:flex-row items-center
          gap-6 md:gap-10 px-6 md:px-12 py-6 w-[90%] md:w-auto"
        >
          <div className="flex items-center gap-4">
            <img src={homeImg} className="w-[50px] md:w-[80px]" />
            <div>
              <h3 className="font-semibold">+259</h3>
              <p className="text-gray-500 text-sm">Homes Delivered</p>
            </div>
          </div>

          <div className="hidden md:block w-[2px] h-[80px] bg-gray-400"></div>

          <div className="flex items-center gap-4">
            <img src={brickImg} className="w-[50px] md:w-[80px]" />
            <div>
              <h3 className="font-semibold">+53</h3>
              <p className="text-gray-500 text-sm">Under Construction</p>
            </div>
          </div>

          <div className="hidden md:block w-[2px] h-[80px] bg-gray-400"></div>

          <div className="flex items-center gap-4">
            <img src={shieldImg} className="w-[60px]" />
            <div>
              <h3 className="font-semibold">+95</h3>
              <p className="text-gray-500 text-sm">NPS Score</p>
            </div>
          </div>
        </div>
      </section>

      <div className="h-[140px] md:h-[100px]"></div> */}
      <section className="pt-[90px] px-4 md:px-[120px]  bg-[#f5f5f5] mt-8">
        <div className="grid md:grid-cols-2 items-center gap-8">
          {/* LEFT CONTENT */}
          <div className="text-center md:text-left">
            <h1 className="text-[28px]  sm:text-[32px] md:text-[55px] lg:text-[65px] leading-[36px] sm:leading-[40px] md:leading-[65px] font-semibold">
              BUILD <br />
              BEYOND <br />
              EXPECTATION
            </h1>

            <p className="mt-4 text-gray-500 text-[13px] sm:text-[14px] md:text-[18px]">
              Build your dream home hassle-free with TORANA.
            </p>

            {/* STATS */}
            <div className="flex flex-wrap justify-center items-center md:justify-start gap-10 mt-6">
              {/* ITEM */}
              <div className="text-center">
                <img src={homeImg} className="w-[45px] mx-auto mb-1" />
                <p className="text-lg font-semibold">+259</p>
                <p className="text-xs text-gray-500">Homes Delivered</p>
              </div>

              {/* ITEM */}
              <div className="text-center">
                <img src={brickImg} className="w-[45px] mx-auto mb-1" />
                <p className="text-lg font-semibold">+53</p>
                <p className="text-xs text-gray-500">
                  Homes Under Construction
                </p>
              </div>

              {/* ITEM */}
              <div className="text-center">
                <div className="relative w-[45px] mx-auto mb-1">
                  <img src={shieldImg} className="w-full" />
                  <span className="absolute inset-0 flex items-center justify-center text-[8px] font-bold">
                    NPS
                  </span>
                </div>
                <p className="text-lg font-semibold">+95</p>
                <p className="text-xs text-gray-500">NPS Score</p>
              </div>
            </div>

            <button
              onClick={() => setOpenModal(true)}
              className="mt-6 px-6 py-2 bg-[#6c4ccf] text-white rounded-md"
            >
              Book a meeting
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end">
            <img
              src={heroImg}
              alt="home"
              className="w-full md:w-[110%] max-w-[500px] md:max-w-none rounded"
            />
          </div>
        </div>
      </section>

      <div className="h-[80px] md:h-[90px] bg-[#f5f5f5]"></div>
      {/* ================= WHY CHOOSE US ================= */}
      <section className="bg-[#f1e7ff] py-[60px] text-center px-6">
        <h2 className="text-2xl font-serif font-bold">WHY CHOSE US</h2>
        <p className="mt-2 mb-8">
          Build your dream home hassle-free with <b>TORANA</b>.
        </p>

        <div className="flex flex-wrap justify-center gap-10">
          {features.map((item, i) => (
            <div key={i} className="bg-[#e5d4ff] p-6 rounded-xl w-[250px]">
              <div className="bg-white w-[55px] h-[50px] flex items-center justify-center rounded-full mx-auto mb-4">
                <img src={item.img} className="w-[30px]" />
              </div>

              <h3 className="font-semibold font-poppins ">{item.title}</h3>

              <p className="text-[14px] text-gray-600 mt-2">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ================= PROJECTS ================= */}
      <section className="py-[60px] text-center px-6">
        <h2 className="text-2xl font-serif font-bold">Our Projects</h2>
        <p className="mt-2 mb-8">
          Build your dream home hassle-free with <b>TORANA</b>.
        </p>
        <div className="flex items-center justify-center gap-4 mt-6">
          {/* LEFT BUTTON */}
          <button
            onClick={prevSlide}
            className="text-2xl px-3 py-1 hover:text-purple-600"
          >
            ❮
          </button>

          {/* LEFT IMAGE */}
          <img
            src={projects[index].left}
            className="hidden md:block w-[220px] h-[320px] rounded-xl object-cover"
          />

          {/* CENTER IMAGE */}
          <img
            src={projects[index].center}
            className="w-[90%] md:w-[600px] h-[360px] md:h-[450px] rounded object-cover transition-all duration-600"
          />

          {/* RIGHT IMAGE */}
          <img
            src={projects[index].right}
            className="hidden md:block w-[220px] h-[300px] rounded-xl object-cover"
          />

          {/* RIGHT BUTTON */}
          <button
            onClick={nextSlide}
            className="text-2xl px-3 py-1 hover:text-purple-600"
          >
            ❯
          </button>
        </div>
        <div className="mt-6 flex justify-center gap-2">
          {projects.map((_, i) => (
            <span
              key={i}
              onClick={() => setIndex(i)}
              className={`h-[6px] rounded-full cursor-pointer transition-all
        ${i === index ? "w-[20px] bg-purple-500" : "w-[6px] bg-gray-300"}`}
            ></span>
          ))}
        </div>
        <p className="mt-4 text-[14px] text-gray-500">
          Wondering how much it'll cost to build your home? Just fill out the
          form and get an <br /> estimate. Our expert can help fine-tune the
          details.
        </p>
        <button
          className="mt-6 border border-black px-6 py-2 rounded 
  transition-all duration-300 ease-in-out
  hover:bg-black hover:text-white hover:scale-105"
        >
          View more
        </button>
      </section>

      <section className="py-8 px-4 text-center">
        {/* BANNER */}
        <div className="w-full max-w-[1100px] mx-auto">
          <video
            ref={videoRef}
            src={yourVideo}
            autoPlay
            loop
            muted
            onTimeUpdate={handleTimeUpdate}
            className="w-full h-[80%] object-cover"
          />

          {/* Timeline */}
          <div
            className="w-full h-[6px] bg-gray-300 mt-2 cursor-pointer rounded"
            onClick={handleSeek}
          >
            <div
              className="h-full bg-[#6c4ccf]  rounded"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="pt-8">
          <button
            onClick={() => setOpenModal(true)}
            className="mt-6 px-6 py-2 bg-[#6c4ccf] text-white rounded-md"
          >
            Book a meeting
          </button>
          <p className="text-gray-500 text-sm max-w-[600px] mx-auto mt-5 leading-relaxed px-2">
            Wondering how much it'll cost to build your home? Just fill out the
            form and get an estimate. Our expert can help fine-tune the details.
          </p>
        </div>
      </section>
      {/* ================= PACKAGES ================= */}
      <section className="bg-[#f1e7ff] py-[40px] px-6 text-center">
        <h2 className="text-[32px] font-serif">Packages</h2>
        <p className="text-gray-500 ">
          Discover the package that fits your needs.
        </p>
        <div className=" items-center gap-2">
          <div className="relative">
            <button
              onClick={() => setIsModalOpen(true)}
              className="h-[38px] pl-3 pr-8 text-[#6c4ccf] bg-transparent outline-none cursor-pointer font-[Poppins] appearance-none border border-transparent"
            >
              {selectedCity}
            </button>

            {/* Custom Arrow */}
            <span className="absolute  top-1/2 -translate-y-1/2 text-[#6c4ccf] pointer-events-none">
              ❯
            </span>
          </div>
        </div>
        <PackagesSection city={selectedCity} />
      </section>

      {/* ================= PROCESS ================= */}
      <section className="bg-[#f6f0ff] py-[80px] px-6 text-center">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-center">
          {[
            {
              img: meetImg,
              title: "Meet our experts",
              description:
                "Discuss your ideas and goals. We'll help plan your budget and design preferences.",
            },
            {
              img: designHome,
              title: "Design your home",
              description:
                "See detailed 3D renderings that let you visualise your home before construction begins.",
            },
            {
              img: trackImg,
              title: "Track construction",
              description:
                "Stay informed with regular updates on progress and quality checks at every stage.",
            },
            {
              img: moveImg,
              title: "Move in",
              description:
                "A pre-delivery inspection ensures everything is in place before handover.",
            },
          ].map((item, index) => (
            <React.Fragment key={index}>
              <div className="max-w-[220px]">
                <img src={item.img} className="h-[180px] mx-auto mb-4" />
                <h3 className="font-bold">{item.title}</h3>
                <p className="font-[12px] text-gray-700">{item.description}</p>
              </div>

              {index !== 3 && (
                <div className="hidden md:block w-[60px] h-[1px] bg-gray-500 mx-4 mt-[80px]"></div>
              )}
            </React.Fragment>
          ))}
        </div>

        <button
          className="mt-6 border border-black px-6 py-2 rounded 
  transition-all duration-300 ease-in-out
  hover:bg-black hover:text-white hover:scale-105"
        >
          View more
        </button>
      </section>

      {/* ================= CUSTOMERS ================= */}

      <section className="bg-[#f6f0ff] py-[60px] text-center px-6">
        <h2 className="text-[32px] font-serif">Happy customers</h2>
        <p className="text-gray-500 mt-2 mb-10">
          Don’t believe us? See what our customers have to say.
        </p>

        <div className="flex flex-wrap justify-center gap-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="w-[320px] h-[180px] bg-[#eee4ff] rounded-xl flex items-center justify-center hover:scale-105 transition cursor-pointer"
            >
              <FaYoutube className="text-red-500 text-5xl" />
            </div>
          ))}
        </div>

        <button className="mt-10 px-6 py-2 border rounded border-black hover:bg-black hover:text-white transition">
          View more
        </button>
      </section>
      {/* Book meeting  */}
      <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#d7c8f2] via-[#c5b7ea] to-[#e5b5d6] px-4 py-10">
        <div className="max-w-[900px] w-full text-center">
          {/* TITLE */}
          <h2 className="text-[24px] md:text-[28px] font-semibold">
            You Dream. We Deliver.
          </h2>

          <p className="text-gray-600 text-[13px] md:text-[14px] mt-2 mb-8">
            Ready to build your dream home? Schedule a free consultation to
            start your journey today.
          </p>

          {/* CARD */}
          <div className="bg-[#f3f3f3] p-6 md:p-8 rounded-xl shadow-sm">
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* INPUTS */}
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="email"
                placeholder="Email"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="tel"
                placeholder="Mobile Number"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                <option>Choose City</option>
                <option>Bhubaneswar</option>
                <option>Cuttack</option>
                <option>Delhi</option>
              </select>

              {/* FLOATING LABEL FIELD */}
              <div className="relative md:col-span-1">
                <label className="absolute -top-2 left-3 bg-[#f3f3f3] px-1 text-[11px] text-gray-500">
                  I want to start conversation in
                </label>

                <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                  <option>0-3 months</option>
                  <option>3-6 months</option>
                  <option>6-12 months</option>
                </select>
              </div>

              {/* RADIO */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm">
                <p>Do you own a plot or land?</p>

                <div className="flex gap-4">
                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    Yes
                  </label>

                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    No
                  </label>
                </div>
              </div>

              {/* CHECKBOX */}
              <div className="flex items-start gap-2 md:col-span-2 text-[12px] text-gray-600">
                <input type="checkbox" className="mt-1" />
                <p>
                  I agree to{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Privacy Policy
                  </span>{" "}
                  and{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Terms & Conditions
                  </span>
                </p>
              </div>

              {/* BUTTON */}
              <button className="md:col-span-2 w-full py-3 rounded-lg text-white text-sm font-medium bg-gradient-to-r from-purple-300 to-purple-500 hover:opacity-90 transition">
                Book a meeting
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
      {/* ================= CITY MODAL (ONLY ONCE) ================= */}
      <CityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
      />
      <BookMeetingModal openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
}

export default Home;
